<template>
  <li :class="['status-item', { 'selected': selected }]">
    <div class="status-item-row">
      <div class="status-item-left">
        <a href="javascript:void(0);" @click="$emit('select')" class="index-link">
          <span class="display-index">{{ displayIndex }}</span>
        </a>
        <template v-if="viewMode == 'view'">
          <span v-if="showMeasurement">{{ value }} <span v-html="measureSuffix"></span></span>
          <span class="area-label">{{ labelText }}</span>
        </template>
        <template v-if="viewMode == 'edit'">
          <span v-if="showMeasurement">{{ value }} <span v-html="measureSuffix"></span></span>
          <span class="area-label">{{ labelText }}</span>
          <a @click="showAreaLabelPrompt" title="Edit this label"><pencil-icon class="icon-2x" /></a>
        </template>
      </div>
      <div class="status-item-right" v-if="viewMode == 'edit'">
        <b-switch v-if="enableCutout" v-model="cutoutValue" size="is-small">Subtract</b-switch>
        <a @click="$emit('delete')" title="Delete this measurement"><delete-icon class="icon-2x" /></a>
      </div>
    </div>
  </li>
</template>

<script>
import { computed } from 'vue'
import { useDialogsStore } from '@/stores/dialogs'

export default {
  emits: ['select', 'delete', 'cutout-change', 'label-change'],
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    measureSuffix: {
      type: String,
      default: ''
    },
    enableFillColor: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    },
    enableCutout: {
      type: Boolean,
      default: false
    },
    cutout: {
      type: Boolean,
      default: false
    },
    distanceVisible: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: ''
    },
    displayIndex: {
      type: Number,
      default: 0
    },
    showMeasurement: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'edit'
    }
  },
  setup(props, { emit }) {
    const dialogsStore = useDialogsStore()

    const cutoutValue = computed({
      get() {
        return props.cutout
      },
      set(value) {
        emit('cutout-change', value)
      }
    })

    const showAreaLabelPrompt = () => {
      dialogsStore.prompt(0, {
        title: 'Set Area Label',
        type: 'is-success',
        message: 'Enter a label for the shape. This will help identify the measurement in your results.',
        inputAttrs: {
          placeholder: 'Enter area label',
          type: 'text',
          trapFocus: true
        },
        confirmText: 'Set Label',
        onConfirm: (value) => {
          emit('label-change', value)
        }
      })
    }

    return {
      cutoutValue,
      showAreaLabelPrompt
    }
  }
}
</script>

<style scoped>
.status-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.status-item-left {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
}

.status-item-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.25rem;
}

span.display-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 15px;
  background-color: #000;
  border: 1px solid #fff;
  border-radius: 50%;
  text-align: center;
  width: 25px;
  height: 25px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  margin-right: 10px;
}

span.area-label {
  font-weight: bold;
  margin: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.index-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
